/* eslint-disable */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {BaseHttpService, ResourceHelper} from '../../util/http-services';
import {ResourceQueryResult} from '../../util/services';
import {Map as ImmutableMap} from 'immutable';
import {DownloadedFile} from "../../util/downloaded-files";
import {UrlBuilder} from "../../../util/url-builder";
import {map} from "rxjs/operators";
import {OrderResource} from "../../order/order-resource.service";

/* eslint-enable */

@Injectable()
export class TaskStatisticsResourceService extends BaseHttpService {

  query(request: TaskStatisticsResource.QueryRequest): Observable<TaskStatisticsResource.TaskStatistic[]> {
    return this.http.get<TaskStatisticsResource.TaskStatistic[]>(this.url + 'log-stat', this.parseParams(request));
  }

  getSimpleStat(request: { helpdesk_enabled?: boolean }): Observable<TaskStatisticsResource.SimpleStat> {
    return this.http.get<TaskStatisticsResource.SimpleStat>(this.url + 'simple-stat', this.parseParams(request));
  }

  getHelpdeskStat(): Observable<ImmutableMap<string, number>> {
    return this.http.get<ImmutableMap<string, number>>(this.url + 'helpdesk-stat');
  }

  exportXlsx(request: TaskStatisticsResource.QueryRequest): Observable<DownloadedFile> {
    const url = UrlBuilder.create('/tasks/statistics/log-stat/export-xls')
      .baseUrl(this.resourceHelper.getBaseUrl())
      .build();
    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob',
      params: this.parseParams(request).params
    }).pipe(map((res) => {
      return new DownloadedFile(res);
    }));
  }

  constructor(private http: HttpClient, private resourceHelper: ResourceHelper) {
    super(resourceHelper, '/tasks/statistics/');
  }

}

export namespace TaskStatisticsResource {

  export interface QueryRequest {
    task_id?: string;
    user_id?: string;
    from_date?: string;
    to_date?: string;
    order?: string;
    page_number?: number;
    number_of_items?: number;
  }

  export interface TaskStatistic {
    task_id: number;
    id: string;
    user_id: number;
    create_count: number;
    start_count: number;
    open_count: number;
    recall_count: number;
    reject_count: number;
    finish_count: number;
  }

  export interface SimpleStat {
    state_stat: Map<string, number>;
    overdue_count: number;
  }

}
